import { CustomField } from '@/api';
import { Board, BoardFolder } from '@/api';
import { orderBy } from 'lodash-es';

export function sortString(a: string, b: string) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0; // equal
}

/**
 * Predicate function for sorting items and folders by `parentRank`.
 */
export function parentRankPredicate(
  a: { parentRank?: string },
  b: { parentRank?: string }
): number {
  return a.parentRank?.localeCompare(b.parentRank || '') || 0;
}

/**
 * Predicate function for sorting items by `boardRankBelow`.
 */
export function boardRankPredicate(
  a: { boardRank?: string },
  b: { boardRank?: string }
): number {
  return a.boardRank?.localeCompare(b.boardRank || '') || 0;
}

export function sortBoardEntities<T extends BoardFolder | Board>(
  entities: T[]
): T[] {
  return orderBy(entities, (e) => [e.archived, e.label], ['asc', 'asc']); // put archived stuff at the end
}

export function sortCycles<T extends Board>(entities: T[]): T[] {
  return orderBy(entities, (e) => [e.archived, e.startDate], ['asc', 'asc']); // put archived stuff at the end
}

export function getCustomFieldSortKey(customFieldId: CustomField['id']) {
  return `customField:${customFieldId}` as const;
}
